import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import React from 'react'
import EmailIcon from '@mui/icons-material/Email'
import { HelpCenterCardSupportButtonProps } from './_props'
import { PhoneIcon } from '../../assets/icons/icons'
import sxs from './_styles/HelpCenterCardsSx'
import sxsButton from './_styles/HelpButtonsSx'
import { SUPPORT_PHONE } from '../../constants/types'

const HelpCenterCardSupportButton: React.FC<HelpCenterCardSupportButtonProps> = ({ email }) => (
    <Box sx={[sxs.cardNoAction, email ? sxs.cardNoActionWithEmail : null]}>
        <Box sx={sxs.cardActionInnerContainer}>
            <PhoneIcon />
            <Typography>Tél. : {SUPPORT_PHONE}</Typography>
        </Box>

        {email && (
            <Box sx={sxs.cardActionInnerContainer}>
                <EmailIcon />
                <Link href="mailto:service@toktokdoc.com" sx={sxsButton.buttonInnerLink}>
                    service@toktokdoc.com
                </Link>
            </Box>
        )}

        <Typography textAlign="center">
            Du lundi au vendredi, de 08h30 à 18h (hors jours fériés français et alsaciens)
        </Typography>
    </Box>
)

export default HelpCenterCardSupportButton
